import { CompLinearProgressCore } from '../core/linear-progress/comp'

export const CompLinearProgress = CompLinearProgressCore
